import React from 'react';
import { useTranslation } from 'react-i18next';
import WizardStep from '../WizardStep';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Sparkles, Package } from 'lucide-react';

interface ReadyStepProps {
  productCount: number;
  onOptimizeAll: () => void;
  onFinish: () => void;
  onBack: () => void;
}

const ReadyStep: React.FC<ReadyStepProps> = ({ productCount, onOptimizeAll, onFinish, onBack }) => {
  const { t } = useTranslation('wizard');

  if (productCount === 0) {
    return (
      <WizardStep title={t('ready.emptyTitle')} hideNext hideBack>
        <div className="flex flex-col items-center text-center space-y-4 py-2">
          <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center">
            <Package className="w-7 h-7 text-muted-foreground" />
          </div>
          <p className="text-sm text-muted-foreground">{t('ready.emptyBody')}</p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Button variant="outline" size="sm" onClick={onBack}>{t('ready.chooseOther')}</Button>
            <Button size="sm" onClick={onFinish}>{t('ready.toDashboard')}</Button>
          </div>
        </div>
      </WizardStep>
    );
  }

  return (
    <WizardStep title={t('ready.title')} hideNext hideBack>
      <div className="flex flex-col items-center text-center space-y-4 py-2">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle2 className="w-7 h-7 text-primary" />
        </div>
        <p className="text-sm text-muted-foreground break-words">{t('ready.body')}</p>
        <Button onClick={onOptimizeAll} className="min-w-[200px]">
          <Sparkles className="w-4 h-4 mr-2" />
          {t('ready.optimizeAll', { count: productCount })}
        </Button>
        <button
          type="button"
          onClick={onFinish}
          className="text-xs text-muted-foreground hover:text-foreground underline"
        >
          {t('ready.later')}
        </button>
      </div>
    </WizardStep>
  );
};

export default ReadyStep;
